import React, { useRef, useState, useEffect } from 'react';
import { useParams } from "react-router";
import { Skeleton, Empty, Button, message, Modal, List } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import { IMAGES, UPLOADS, FILES } from '../../../../params';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation, Autoplay } from 'swiper';
import { IoIosArrowDown } from "react-icons/io";
import 'swiper/swiper.min.css';
import "swiper/components/pagination/pagination.min.css";
import 'swiper/components/navigation/navigation.min.css';
import { TbReload } from "react-icons/tb";
SwiperCore.use([Autoplay, Navigation, Pagination]);

export const Item = props => {
    
    const dispatch = useDispatch();
    const app_global = useSelector(state => state.app_global);
    
    const navigationPrevRef = React.useRef(null)
    const navigationNextRef = React.useRef(null)

    const [tabsActiveSection_1, setTabsActiveSection_1] = useState(false);
    const [tabsActiveSection_2, setTabsActiveSection_2] = useState(false);
    const [tabsActiveSection_3, setTabsActiveSection_3] = useState(false);
    const [tabsActiveSection_4, setTabsActiveSection_4] = useState(false);
    const [tabsActiveSection_5, setTabsActiveSection_5] = useState(false);
    const [tabsActiveSection_6, setTabsActiveSection_6] = useState(false);

    const [activeModal, setActiveModal] = useState("");

    const [page, setPage] = useState(1);
    const [page2, setPage2] = useState(1);
    const [paginationSize, setPaginationSize] = useState(6);

    const video_01 = useRef(null);
    const [video_01_status, setVideo_01_status] = useState(false);

    const video_02 = useRef(null);
    const [video_02_status, setVideo_02_status] = useState(false);

    const video_03 = useRef(null);
    const [video_03_status, setVideo_03_status] = useState(false);

    const video_04 = useRef(null);
    const [video_04_status, setVideo_04_status] = useState(false);

    const video_05 = useRef(null);
    const [video_05_status, setVideo_05_status] = useState(false);

    const params = useParams();

    const isInitialMount = useRef(true);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;

            component_start();
        }
    }, []);

    async function component_start() {
        
    }

    async function video_01_status_change() {
        if (video_01?.current?.paused) { 
            video_01?.current?.play()
            setVideo_01_status(true);
        } else {
            video_01?.current?.pause();
            setVideo_01_status(false);
        }
    }

    async function video_02_status_change() {
        if (video_02?.current?.paused) { 
            video_02?.current?.play()
            setVideo_02_status(true);
        } else {
            video_02?.current?.pause();
            setVideo_02_status(false);
        }
    }

    async function video_03_status_change() {
        if (video_03?.current?.paused) { 
            video_03?.current?.play()
            setVideo_03_status(true);
        } else {
            video_03?.current?.pause();
            setVideo_03_status(false);
        }
    }

    async function video_04_status_change() {
        if (video_04?.current?.paused) { 
            video_04?.current?.play()
            setVideo_04_status(true);
        } else {
            video_04?.current?.pause();
            setVideo_04_status(false);
        }
    }

    async function video_05_status_change() {
        if (video_05?.current?.paused) { 
            video_05?.current?.play()
            setVideo_05_status(true);
        } else {
            video_05?.current?.pause();
            setVideo_05_status(false);
        }
    }

    return (
        <>
            {
                app_global.loading ?
                <section className='container shadow default_padding marginTop'>
                    <div className='content'>
                        <Skeleton active />
                    </div>
                </section>
            :
                <>
                    <section className='container_full --hls_item_11'>
                        <section className='top'>
                            <section className='container shadow default_padding'>
                                <h1>Медитации для быстрого отхода ко сну</h1>
                            </section>
                        </section>
                        <section className='body'>
                            <section className='container shadow default_padding'>
                                <section className='left'>
                                    <p className='title'>Рекомендуем ознакомиться</p>
                                    <p className='excerpt'>Прочитав статьи вы сможете качественно улучшить текущее состояние вашего здоровья.</p>
                                    <div className='slider_pc'>
                                        <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                            <div className='article_background'>
                                                <img src={`${IMAGES}/banners/hls_image_00.jpeg`} />
                                            </div>
                                            <div className='article_column'>
                                                <div className='article_column_left'>
                                                    <div className='article_title'>Здоровый образ жизни</div>
                                                </div>
                                                <div className='article_column_right'>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </Link>
                                        <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                            <div className='article_background'>
                                                <img src={`${IMAGES}/banners/hls_image_01.jpeg`} />
                                            </div>
                                            <div className='article_column'>
                                                <div className='article_column_left'>
                                                    <div className='article_title'>Правильное питание</div>
                                                </div>
                                                <div className='article_column_right'>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </Link>
                                        <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                            <div className='article_background'>
                                                <img src={`${IMAGES}/banners/hls_image_02.jpeg`} />
                                            </div>
                                            <div className='article_column'>
                                                <div className='article_column_left'>
                                                    <div className='article_title'>Физическая активность</div>
                                                </div>
                                                <div className='article_column_right'>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className='slider_mob'>
                                        <Swiper
                                            loop
                                            spaceBetween={12}
                                            slidesPerView={1.5}
                                            pagination={{
                                                type: "progressbar",
                                            }}
                                            navigation={{
                                                prevEl: navigationPrevRef.current,
                                                nextEl: navigationNextRef.current,
                                            }}
                                            onBeforeInit={(swiper) => {
                                                swiper.params.navigation.prevEl = navigationPrevRef.current;
                                                swiper.params.navigation.nextEl = navigationNextRef.current;
                                            }}
                                            breakpoints={{
                                                992: {
                                                    slidesPerView: 2.75,
                                                },
                                                991: {
                                                    slidesPerView: 2,
                                                },
                                                700: {
                                                    slidesPerView: 1.5,
                                                },
                                            }}
                                        >
                                            <SwiperSlide>
                                                <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                    <div className='article_background'>
                                                        <img src={`${IMAGES}/banners/hls_image_00.jpeg`} />
                                                    </div>
                                                    <div className='article_column'>
                                                        <div className='article_column_left'>
                                                            <div className='article_title'>Здоровый образ жизни</div>
                                                        </div>
                                                        <div className='article_column_right'>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                    <div className='article_background'>
                                                        <img src={`${IMAGES}/banners/hls_image_01.jpeg`} />
                                                    </div>
                                                    <div className='article_column'>
                                                        <div className='article_column_left'>
                                                            <div className='article_title'>Правильное питание</div>
                                                        </div>
                                                        <div className='article_column_right'>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                    <div className='article_background'>
                                                        <img src={`${IMAGES}/banners/hls_image_02.jpeg`} />
                                                    </div>
                                                    <div className='article_column'>
                                                        <div className='article_column_left'>
                                                            <div className='article_title'>Физическая активность</div>
                                                        </div>
                                                        <div className='article_column_right'>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                        </Swiper>
                                    </div>
                                </section>
                                <section className='right'>
                                    <div className='content'>
                                        <div className='header'>
                                            <div className='posts_image_big'>
                                                <img src={`${IMAGES}/banners/hls_image_04_05_01.jpeg`} />
                                            </div>
                                        </div>

                                        <div className='body'>
                                            <div className='text_content'>
                                                <p>Мы предлагаем вам разнообразные медитативные практики, которые помогут вам снять напряжение, успокоить ум и быстро заснуть. Здесь вы найдете описание медитаций для расслабления, которые помогут вам создать благоприятную атмосферу для погружения в мир медитации. На странице вы найдете не только описание медитаций, но и видео с медитативной музыкой и успокаивающими кадрами, которые помогут вам снять напряжение и расслабиться.</p>
                                            </div>
                                            <div className='list_category'>
                                                <div className={`list_item${tabsActiveSection_1 ? ' active' : '' }`}>
                                                    <div className='visible'>
                                                        <img className='banner' src={`${IMAGES}/banners/hls_image_04_05_02.jpeg`} />
                                                        <div className='right_info'>
                                                            <div className='info'>
                                                                <div className='title'>Медитация на засыпание с использованием визуализации</div>
                                                                <div className='description'>Медитация на засыпание с использованием визуализации может помочь уменьшить стресс, беспокойство и напряжение, которые могут мешать заснуть. Она также может помочь улучшить качество сна, уменьшить проблемы со сном и уменьшить риск пробуждения во время ночи.</div>
                                                            </div>
                                                            <div onClick={() => setTabsActiveSection_1(!tabsActiveSection_1)} className={`ant-btn ant-btn-primary default button_more ${tabsActiveSection_1 ? 'active' : null}`} ><span>{tabsActiveSection_1 ? 'Скрыть' : 'Подробнее'}</span><IoIosArrowDown /></div>
                                                        </div>
                                                    </div>
                                                    <div className='hidden'>
                                                        <div className='column'>
                                                            <div className={`custom_video ${video_01_status ? 'play' : 'pause'}`} onClick={video_01_status_change}>
                                                                <video ref={video_01} id="video_01" preload="auto" poster={`${IMAGES}/banners/hls_video_11_01.jpg`} loop>
                                                                    <source id='mp4' src={`${IMAGES}/banners/hls_video_11_01.mp4`} type='video/mp4' />
                                                                </video>
                                                            </div>
                                                            <div className='text_content'>
                                                                <p>Медитация на засыпание с использованием визуализации может помочь уменьшить стресс, беспокойство и напряжение, которые могут мешать заснуть. Она также может помочь улучшить качество сна, уменьшить проблемы со сном и уменьшить риск пробуждения во время ночи.</p>
                                                            </div>
                                                        </div>
                                                        <div className='column'>
                                                            <div className='text_content'>
                                                                <p><strong>Этапы выполнения упражнения:</strong></p>
                                                                <ul>
                                                                    <li><none />Ложитесь в постель и закрывайте глаза</li>
                                                                    <li><none />Представляйте спокойный пейзаж, например, море или лес</li>
                                                                    <li><none />Внимательно представляйте детали, звуки и запахи этого места</li>
                                                                    <li><none />Попробуйте почувствовать покой и расслабление, которое вы испытываете в этом месте</li>
                                                                    <li><none />Продолжайте визуализировать этот мир и сконцентрироваться на своем дыхании, пока не заснете</li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`list_item${tabsActiveSection_2 ? ' active' : '' }`}>
                                                    <div className='visible'>
                                                        <img className='banner' src={`${IMAGES}/banners/hls_image_04_05_03.jpeg`} />
                                                        <div className='right_info'>
                                                            <div className='info'>
                                                                <div className='title'>Медитация на расширение сознания</div>
                                                                <div className='description'>Медитация на расширение сознания может помочь улучшить наше настроение, снизить уровень стресса и тревожности, улучшить способность к концентрации и улучшить нашу способность к творчеству.</div>
                                                            </div>
                                                            <div onClick={() => setTabsActiveSection_2(!tabsActiveSection_2)} className={`ant-btn ant-btn-primary default button_more ${tabsActiveSection_2 ? 'active' : null}`} ><span>{tabsActiveSection_2 ? 'Скрыть' : 'Подробнее'}</span><IoIosArrowDown /></div>
                                                        </div>
                                                    </div>
                                                    <div className='hidden'>
                                                        <div className='column'>
                                                            <div className={`custom_video ${video_02_status ? 'play' : 'pause'}`} onClick={video_02_status_change}>
                                                                <video ref={video_02} id="video_01" preload="auto" poster={`${IMAGES}/banners/hls_video_11_02.jpg`} loop>
                                                                    <source id='mp4' src={`${IMAGES}/banners/hls_video_11_02.mp4`} type='video/mp4' />
                                                                </video>
                                                            </div>
                                                            <div className='text_content'>
                                                                <p>Медитация на расширение сознания может помочь улучшить наше настроение, снизить уровень стресса и тревожности, улучшить способность к концентрации и улучшить нашу способность к творчеству.</p>
                                                            </div>
                                                        </div>
                                                        <div className='column'>
                                                            <div className='text_content'>
                                                                <p><strong>Этапы выполнения упражнения:</strong></p>
                                                                <ul>
                                                                    <li><none />Ложитесь на спину и закройте глаза</li>
                                                                    <li><none />Начните медитировать, сосредоточившись на вашем дыхании</li>
                                                                    <li><none />Затем представьте, как ваше сознание начинает расширяться и заполняет комнату</li>
                                                                    <li><none />Представьте, что вы распространяетесь на всю планету, затем на всю галактику и в конечном итоге на всю Вселенную</li>
                                                                    <li><none />Держите позу ребенка на несколько дыханий или на несколько минут, позволяя телу расслабиться и растянуться</li>
                                                                    <li><none />Для выхода из позы, медленно поднимите таз и вернитесь в положение четвереньки</li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`list_item${tabsActiveSection_3 ? ' active' : '' }`}>
                                                    <div className='visible'>
                                                        <img className='banner' src={`${IMAGES}/banners/hls_image_04_05_04.jpeg`} />
                                                        <div className='right_info'>
                                                            <div className='info'>
                                                                <div className='title'>Медитация на очищение ума</div>
                                                            </div>
                                                            <div onClick={() => setTabsActiveSection_3(!tabsActiveSection_3)} className={`ant-btn ant-btn-primary default button_more ${tabsActiveSection_3 ? 'active' : null}`} ><span>{tabsActiveSection_3 ? 'Скрыть' : 'Подробнее'}</span><IoIosArrowDown /></div>
                                                        </div>
                                                    </div>
                                                    <div className='hidden'>
                                                        <div className='column'>
                                                            <div className={`custom_video ${video_03_status ? 'play' : 'pause'}`} onClick={video_03_status_change}>
                                                                <video ref={video_03} id="video_01" preload="auto" poster={`${IMAGES}/banners/hls_video_11_03.jpg`} loop>
                                                                    <source id='mp4' src={`${IMAGES}/banners/hls_video_11_03.mp4`} type='video/mp4' />
                                                                </video>
                                                            </div>
                                                            <div className='text_content'>

                                                            </div>
                                                        </div>
                                                        <div className='column'>
                                                            <div className='text_content'>
                                                                <p><strong>Этапы выполнения упражнения:</strong></p>
                                                                <ul>
                                                                    <li><none />Сядьте в удобную позу и закройте глаза</li>
                                                                    <li><none />Сосредоточьтесь на вашем дыхании и затем визуализируйте, как ваш ум очищается от всех негативных мыслей и эмоций</li>
                                                                    <li><none />Представьте, что эти мысли и чувства уходят от вас, как облака, и исчезают вдалеке</li>
                                                                    <li><none />Сфокусируйтесь на чистоте и ясности вашего ума и продолжайте медитировать, пока не почувствуете, что ваш ум стал более спокойным и расслабленным</li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`list_item${tabsActiveSection_4 ? ' active' : '' }`}>
                                                    <div className='visible'>
                                                        <img className='banner' src={`${IMAGES}/banners/hls_image_04_05_05.jpeg`} />
                                                        <div className='right_info'>
                                                            <div className='info'>
                                                                <div className='title'>Медитация на расслабление тела</div>
                                                                <div className='description'>Эта медитация поможет снизить уровень напряжения в теле и способствовать расслаблению</div>
                                                            </div>
                                                            <div onClick={() => setTabsActiveSection_4(!tabsActiveSection_4)} className={`ant-btn ant-btn-primary default button_more ${tabsActiveSection_4 ? 'active' : null}`} ><span>{tabsActiveSection_4 ? 'Скрыть' : 'Подробнее'}</span><IoIosArrowDown /></div>
                                                        </div>
                                                    </div>
                                                    <div className='hidden'>
                                                        <div className='column'>
                                                            <div className={`custom_video ${video_04_status ? 'play' : 'pause'}`} onClick={video_04_status_change}>
                                                                <video ref={video_04} id="video_01" preload="auto" poster={`${IMAGES}/banners/hls_video_11_04.jpg`} loop>
                                                                    <source id='mp4' src={`${IMAGES}/banners/hls_video_11_04.mp4`} type='video/mp4' />
                                                                </video>
                                                            </div>
                                                            <div className='text_content'>
                                                                <p>Эта медитация поможет снизить уровень напряжения в теле и способствовать расслаблению</p>
                                                            </div>
                                                        </div>
                                                        <div className='column'>
                                                            <div className='text_content'>
                                                                <p><strong>Этапы выполнения упражнения:</strong></p>
                                                                <ul>
                                                                    <li><none />Сядьте в удобное положение и начните расслаблять каждую часть своего тела</li>
                                                                    <li><none />Медленно расслабляйте каждую часть тела поочередно, начиная с головы и заканчивая стопами</li>
                                                                    <li><none />Визуализируйте, как напряжение покидает каждую часть вашего тела, постепенно углубляясь в состояние расслабления</li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`list_item${tabsActiveSection_5 ? ' active' : '' }`}>
                                                    <div className='visible'>
                                                        <img className='banner' src={`${IMAGES}/banners/hls_image_04_05_06.jpeg`} />
                                                        <div className='right_info'>
                                                            <div className='info'>
                                                                <div className='title'>Медитация на звуки</div>
                                                                <div className='description'>Эта медитация помогает снизить уровень стресса и напряжения, что может помочь улучшить качество сна. Полностью расслабьтесь и приготовьтесь ко сну. Сосредоточьтесь на звуках вокруг вас. Можете слушать шум деревьев, пение птиц или звуки проезжающих машин. Не оценивайте, не судите, просто слушайте</div>
                                                            </div>
                                                            <div onClick={() => setTabsActiveSection_5(!tabsActiveSection_5)} className={`ant-btn ant-btn-primary default button_more ${tabsActiveSection_5 ? 'active' : null}`} ><span>{tabsActiveSection_5 ? 'Скрыть' : 'Подробнее'}</span><IoIosArrowDown /></div>
                                                        </div>
                                                    </div>
                                                    <div className='hidden'>
                                                        <div className='column'>
                                                            <div className={`custom_video ${video_05_status ? 'play' : 'pause'}`} onClick={video_05_status_change}>
                                                                <video ref={video_05} id="video_01" preload="auto" poster={`${IMAGES}/banners/hls_video_11_05.jpg`} loop>
                                                                    <source id='mp4' src={`${IMAGES}/banners/hls_video_11_05.mp4`} type='video/mp4' />
                                                                </video>
                                                            </div>
                                                            <div className='text_content'>
                                                                <p>Эта медитация помогает снизить уровень стресса и напряжения, что может помочь улучшить качество сна. Полностью расслабьтесь и приготовьтесь ко сну. Сосредоточьтесь на звуках вокруг вас. Можете слушать шум деревьев, пение птиц или звуки проезжающих машин. Не оценивайте, не судите, просто слушайте</p>
                                                            </div>
                                                        </div>
                                                        <div className='column'>
                                                            <div className='text_content'>
                                                                <p><strong>Этапы выполнения упражнения:</strong></p>
                                                                <ul>
                                                                    <li><none />Полностью расслабьтесь и приготовьтесь ко сну</li>
                                                                    <li><none />Сосредоточьтесь на звуках вокруг вас. Можете слушать шум деревьев, пение птиц или звуки проезжающих машин. Не оценивайте, не судите, просто слушайте</li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="fcenter custom_bg_text" style={{marginTop:50}}>
                                                <Link to={`/specializations/`} exact={ true } onClick={() => scroll.scrollToTop()} className="submit_mini_white" >Узнайте, как улучшить свой образ жизни</Link>
                                                <Link to={`/hls/surveys/`} exact={ true } onClick={() => scroll.scrollToTop()} className="submit_mini" >Пройдите тест и проверьте своё здоровье</Link>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </section>
                        </section>
                    </section>
                </>
            }
        </>
    );
};